// extracted by mini-css-extract-plugin
export var wrapper = "productPreview-module--wrapper--JzX83";
export var card = "productPreview-module--card--1XsKh";
export var vignette = "productPreview-module--vignette--3N1o9";
export var title = "productPreview-module--title--3bE0D";
export var price = "productPreview-module--price--1yE3C";